import { motion } from "framer-motion";

export const EASE = [0.22, 1, 0.36, 1];

export const MaskLines = ({ lines, as = "h1", className = "", delay = 0, testid }) => {
  const Tag = motion[as];
  return (
    <Tag
      className={className}
      data-testid={testid}
      initial="hidden"
      animate="show"
      variants={{ show: { transition: { staggerChildren: 0.13, delayChildren: delay } } }}
    >
      {lines.map((line, i) => (
        <span key={i} className="block overflow-hidden pb-[0.12em] -mb-[0.12em]">
          <motion.span
            className="block"
            variants={{ hidden: { y: "110%" }, show: { y: "0%", transition: { duration: 1.15, ease: EASE } } }}
          >
            {line}
          </motion.span>
        </span>
      ))}
    </Tag>
  );
};

export const FadeUp = ({ children, className = "", delay = 0, y = 28, ...rest }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, amount: 0.15 }}
    transition={{ duration: 0.9, ease: EASE, delay }}
    {...rest}
  >
    {children}
  </motion.div>
);

export const Eyebrow = ({ children, className = "" }) => (
  <p className={`font-caps text-[12px] tracking-[0.32em] uppercase text-gold-deep flex items-center gap-3 ${className}`}>
    <span className="h-px w-8 bg-gold" aria-hidden="true" />
    {children}
  </p>
);
